
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Config } from 'config/envConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBuilding,
    faUserTie,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@quyva/shared-ui';
import { getUrl } from '../../../pdfDisplay/utils';
import { OrganizationManagement } from './OrganizationManagement';
import { useSettingsContext } from '../../../../context';

export const OrganizationManagementSettings = ({
    SettingSections,
    organizationManagementRef,
}) => {
    const {
        user,
        isSuperAdmin,
        isPartnerOwner,
        isReseller,
    } = useSettingsContext();

    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchOrganizations = async () => {
        try {
            setLoading(true);
            const url = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/get-organizations`
            );
            const authToken = encodeURIComponent(user.token);

            const response = await axios.get(
                `${url}?email=${encodeURIComponent(user.email)}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                    },
                }
            );

            const billingUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/get-member-billing`
            );
            const billingResponse = await axios.get(
                `${billingUrl}?email=${encodeURIComponent(user.email)}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                    },
                }
            );

            const orgsWithBilling = (response.data.organizations || []).map(
                (org) => {
                    const billingInfo =
                        (billingResponse.data.billingData || []).find(
                            (b) => b.organizationId === org.id
                        );
                    return {
                        ...org,
                        billingData: billingInfo || null,
                    };
                }
            );

            setOrganizations(orgsWithBilling);
        } catch (error) {
            console.log('Error fetching organizations:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);

    return (
        <div ref={organizationManagementRef}>
            <div className='flex items-center justify-between font-semibold mb-2 py-3 px-4 text-texts-secondary300 uppercase bg-backgrounds-primary100 truncate'>
                <div className='flex items-center'>
                    <FontAwesomeIcon icon={faUserTie} className='mr-2' />
                    <div className='font-semibold text-texts-secondary300 uppercase truncate'>
                        {SettingSections.ORGANIZATION_MANAGEMENT}
                    </div>
                </div>
                {(isSuperAdmin || isPartnerOwner) && !isReseller && (
                    <Button
                        icon={faBuilding}
                        text='Onboard'
                        hoverText='Onboard a new organization'
                        onClick={() =>
                            document
                                .getElementById('createOrgButton')
                                ?.click()
                        }
                        type='success'
                    />
                )}
            </div>
            <div className='h-[calc(100vh-210px)] w-full overflow-auto'>
                <OrganizationManagement
                    user={user}
                    isSuperAdmin={isSuperAdmin}
                    isPartnerOwner={isPartnerOwner}
                    isReseller={isReseller}
                    organizations={organizations}
                    loading={loading}
                    fetchOrganizations={fetchOrganizations}
                />
            </div>
        </div>
    );
};
